export default {"src":"/_next/static/media/pointed-arrow-right-light.d37b7cbb.svg","height":14,"width":18};